export default function formattedPrice (value, round, lang) {
  const delimiter = lang === 'us' ? ',' : '.'
  const sep = lang === 'us' ? '.' : ','
  if (round) {
    return Math.round(parseFloat(value)).toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, delimiter)
  }
  return parseFloat(value).toFixed(2).replace('.', sep).replace(/\B(?=(\d{3})+(?!\d))/g, delimiter)
}
